import {
  computed, watch, ref,
} from '@vue/composition-api'
import useInstances from '@/compositions/useInstances'

import OrdersTable from '@/views/Personal/components/Orders/components/OrdersTable/OrdersTable'
import TracksTable from '@/views/Personal/components/Tracks/components/TracksTable/TracksTable'
import MaterialDeliveriesTables from '@/views/Personal/components/MaterialDeliveries/components/MaterialDeliveriesTables/MaterialDeliveriesTables'
import OrderDialog from '@/components/OrderDialog'
import OffersCount from '@/components/OffersCount/OffersCount.vue'
import BlackList from '@/components/BlackList/BlackList.vue'

export default ({
  components: {
    OrdersTable,
    TracksTable,
    MaterialDeliveriesTables,
    OrderDialog,
    OffersCount,
    BlackList,
  },
  setup(props, context) {
    const {
      $router, $access, $route, $store,
    } = context.root
    const tableProps = {
      orders: {
        owner: { type: 'owner', state: 'tenders', filter: 'new' },
        owner_waiting: { type: 'owner', state: 'tenders', filter: 'waiting' },
        client: { type: $access('ordersMy') && !$access('ordersRent') ? 'my' : 'client', state: 'tenders', filter: 'new' },
        archive: { type: 'all', state: 'archive' },
      },
      tracks: {
        owner: { type: 'waiting', state: 'owner' },
        client: { type: 'waiting', state: 'client' },
        archive: { type: 'archive', state: '' },
      },
      materials: {
        owner: { type: 'owner', state: 'tender' },
        client: { type: 'client', state: 'tender' },
        archive: { type: 'all', state: 'archive' },
      },
    }
    const isBlacklisted = computed(() => ($store.state.auth.company ? $store.state.auth.company.isBlacklisted : false))
    const activeOrdersCount = computed(() => $store.state.orders.activeOrdersCount)
    const waitingOrdersCount = computed(() => $store.state.orders.waitingOrdersCount)
    const topTabsActive = ref('')
    const bottomTabsActive = ref('')
    const tableType = ref('')
    const tableState = ref('')
    const isUser = computed(() => $store.getters['auth/companyRole'] === 'client')
    const isOpenOrderFormPopup = ref(false)
    const userRole = computed(() => $store.getters['auth/userRole'])
    const filterType = ref('')

    const { instances } = useInstances(context)

    const bottomTabs = computed(() => {
      const tabs = []
      if ($access('orders')) tabs.push('orders')
      if ($access('tracks') && !isUser.value) tabs.push('tracks')
      if ($access('materials')) tabs.push('materials')
      return tabs
    })

    const getPath = (type, state) => `/personal/tenders/${type}/${state}`

    const updateTableParams = () => {
      const { type, state, filter } = tableProps[bottomTabsActive.value][topTabsActive.value]
      tableType.value = type
      tableState.value = state
      filterType.value = filter
    }

    const typeClick = (type) => {
      const newState = $access('orders') ? 'orders' : 'tracks'
      const path = getPath(type, newState)
      $router.push({ path })
    }
    const handleRouteClick = (filter) => {
      const path = getPath('owner', 'orders')
      filterType.value = filter
      $router.push({ path })
    }

    const bottomTabClick = (type) => {
      bottomTabsActive.value = type
      updateTableParams()
    }

    const init = () => {
      const { state: routeState, type: routeType } = $route.params
      topTabsActive.value = routeType
      bottomTabsActive.value = routeState
      updateTableParams()
    }

    watch(() => $route, () => init(), { immediate: true })

    return {
      topTabsActive,
      bottomTabs,
      bottomTabsActive,
      userRole,
      tableType,
      tableState,
      isOpenOrderFormPopup,
      activeOrdersCount,
      waitingOrdersCount,
      filterType,
      isBlacklisted,
      instances,
      typeClick,
      bottomTabClick,
      handleRouteClick,
    }
  },
})
